import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { ForgeProvider } from 'wss3-forge'
import App from './App'
import './index.css'

const forgeTheme = {
  bgPrimary: '#0F0F0F',
  bgSecondary: '#111111',
  bgTertiary: '#1A1A1A',
  textPrimary: '#FFFFFF',
  textSecondary: '#A3A3A3',
  textMuted: '#737373',
  brandPrimary: '#f6a00e',
  brandSecondary: '#f6a00e',
  borderColor: '#262626',
  success: '#22c55e',
  warning: '#f59e0b',
  error: '#ef4444',
  info: '#3b82f6'
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <ForgeProvider mode="dark" theme={forgeTheme}>
        <App />
      </ForgeProvider>
    </BrowserRouter>
  </React.StrictMode>
)
